import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form, Button, Alert, ProgressBar, Modal, Label } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";
import Utils from "../../common/Utils";
import HelpList from "./HelpList";
import ChoosePlans from "../../components/application/ChoosePlans";

const HelpMaterials = (props) => {
  const [userData, setUserData] = useState(Utils.getUserData());
  const initFilter = () => ({ pp: Utils.perpage, txt: "" });

  const [getjcs, setGetjcs] = useState(true);
  const [jcats, setJCats] = useState([]);

  const [filter, setFilter] = useState(initFilter());
  const [data, setData] = useState({
    loading: false,
    total: 0,
    start: 0,
    records: [],
  });
  const [showHelps, setShowHelps] = useState([]);

  const getRecordStart = () => {
    return parseInt(data.start * filter.pp) + 1;
  };

  let stout = null;

  const setSearchTxt = (e) => {
    let txt = e.currentTarget.value;
    if (stout != null) {
      window.clearTimeout(stout);
    }
    stout = window.setTimeout(() => {
      setFilter({ ...filter, st: 0, txt: txt });
    }, 1000);
  };

  const addFilters = (start) => {
    let str = [`pp=${filter.pp}`, `st=${start}`, `getjcs=${getjcs ? "yes" : "no"}`, `txt=${filter.txt}`];

    return "?" + str.join("&");
  };

  const fetchData = (start = 0) => {
    setData({ ...data, loading: true });
    axios
      .get(Utils.apiUrl("help/fetchbyjobcat") + addFilters(start), Utils.apiHeaders())
      .then((res) => {
        let tmpData = {
          ...data,
          total: 0,
          start: 0,
          records: [],
          loading: false,
        };
        if (res.data.success) {
          setGetjcs(false);

          if (_.get(res, "data.data.jcats", []).length > 0) {
            setJCats(res.data.data.jcats);
          }
          tmpData = {
            ...tmpData,
            start: start,
            records: res.data.data.help,
          };

          tmpData["total"] = res.data.total;
        }

        console.log(tmpData);
        setData(tmpData);
      })
      .catch((err) => {
        setData({ ...data, loading: false });
        console.log(err);
      });
  };

  useEffect(fetchData, [filter]);

  const showPagination = ({ loading, start, total }) => {
    if (loading || (start === 0 && start + filter.pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {start + filter.pp >= total && (
            <div className="text-disabled ms-2">
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
            </div>
          )}
          {start + filter.pp < total && (
            <div className="clickable ms-2 text-clickable" onClick={() => fetchData(start + filter.pp)}>
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
            </div>
          )}
          {start >= filter.pp && (
            <div className="clickable text-clickable" onClick={() => fetchData(start - filter.pp)}>
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
            </div>
          )}
          {start === 0 && (
            <div className="text-disabled">
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
            </div>
          )}
        </div>
      );
    }
  };

  const pageSelect = () => {
    return (
      <select
        className="form-select float-right ms-3"
        style={{ width: "80px" }}
        onChange={(e) => setFilter({ ...filter, pp: parseInt(e.target.value) })}
      >
        {[5, 10, 25, 50, 100].map((p) => (
          <option value={p} selected={filter.pp === p}>
            {p}
          </option>
        ))}
      </select>
    );
  };
  if (!Utils.hasAccess(8)) {
    return (
      <>
        {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  return (
    <React.Fragment>
      <div>
        <Row>
          <Col>
            <h3 className="my-3 title">Help Materials</h3>
            <Form>
              <Row className="gx-1">
                <Col className="d-none d-sm-block">
                  <Button variant="light" className="style1 w-100 radius-left shadow-cst">
                    <img src={`${process.env.PUBLIC_URL}/images/filter.png`} className="me-3" alt="Filter" /> Filter
                  </Button>
                </Col>
                <Col xs={6} lg={8}>
                  <input
                    type="text"
                    className="form-control form-control-select form-select shadow-cst"
                    placeholder="Search by Job Title, Category or File Name"
                    onKeyUp={setSearchTxt}
                  />
                </Col>

                <Col>
                  <Button variant="light" className="style1 w-100 radius-right shadow-cst" onClick={() => setFilter(initFilter())}>
                    Clear filter
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card border="light" className="shadow table-section p-sm-0 p-lg-1">
              <Card.Body>
                {data.loading && (
                  <Alert variant="success" className="p-3">
                    <p className="loading-msg">Fetching help materials.. </p>
                    <ProgressBar variant="success" animated now={100} />
                  </Alert>
                )}
                {!data.loading && (
                  <>
                    <div className="d-flex flex-row-reverse">
                      {pageSelect()}
                      {showPagination(data)}
                    </div>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th>Job</th>
                          <th>Job Category</th>
                          <th>Help Materials</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.records.length === 0 && (
                          <tr>
                            <td colspan="3">
                              <Alert variant="danger" className="text-center p-5">
                                No Help material found!
                              </Alert>
                            </td>
                          </tr>
                        )}
                        {data.records.map((d, idx) => {
                          return (
                            <tr key={d.id}>
                              <td className="align-middle">{d.name}</td>
                              <td className="align-middle">{d.cname}</td>
                              <td className="align-middle">
                                <Button onClick={() => setShowHelps(d.help.split("::"))}>View Materials ({d.helps})</Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    <div className="d-flex flex-row-reverse">
                      {pageSelect()}
                      {showPagination(data)}
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {showHelps.length > 0 && <HelpList data={showHelps} onHide={() => setShowHelps([])} />}
      </div>
    </React.Fragment>
  );
};

export default HelpMaterials;
